/**
 * Private modules
 */
const {
  createQueryComponent,
  creditAmount,
  customerId,
  objectId,
  systemGameId,
  systemGameTypeId,
} = require('../.private').components;

/**
 * Scopes
 */
const {
  CUSTOMER_RELATIONSHIPS_ANCESTOR_BY_SYSTEM_GAME_ID,
  CUSTOMER_RELATIONSHIPS_INPUT_BY_SYSTEM_GAME_ID,
  DEFAULT,
} = require('../../scopes');

module.exports = {
  getCustomerAncestorRunnerLimitsBySystemGameTypeId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameTypeId,
        },
        required: [
          'customerId',
          'systemGameTypeId',
        ],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getCustomerById: {
    properties: {
      params: {
        properties: {
          objectId,
        },
        required: ['objectId'],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getCustomerRelationshipsBySystemGameId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
      query: createQueryComponent([
        CUSTOMER_RELATIONSHIPS_ANCESTOR_BY_SYSTEM_GAME_ID,
        CUSTOMER_RELATIONSHIPS_INPUT_BY_SYSTEM_GAME_ID,
        DEFAULT,
      ]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  updateCustomerById: {
    properties: {
      body: {
        properties: {
          creditAmount,
        },
        required: ['creditAmount'],
        type: 'object',
      },
      params: {
        properties: {
          objectId,
        },
        required: ['objectId'],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
};
